export const DEFAULT_VOLUME = 1;